<template>
    <div :class="[$store.state.layout_style, $store.state.menu_style]">
        <component v-bind:is="layout"></component>
    </div>
</template>
<script>
    // layouts
    import appLayout from './layouts/app-layout.vue';
    import authLayout from './layouts/auth-layout.vue';
    import custLayout from './layouts/cust-layout.vue';
    import custAuthLayout from './layouts/cust-auth-layout.vue';
    import axios from 'axios';
    import '@/assets/sass/app.scss';

    export default {
        metaInfo: {
            title: 'Home',
            titleTemplate: '%s',
        },
        components: {
            app: appLayout,
            auth: authLayout,
            cust: custLayout,
            cust_auth: custAuthLayout,
        },
        computed: {
            layout() {
                return this.$store.getters.layout;
            },
        },
        data() {
            return {};
        },
        mounted() {
            const getSelectedCenterIdFromCookie = () => {
                const cookies = document.cookie.split('; ');
                const selectedCenterCookie = cookies.find((cookie) => cookie.startsWith('selected_center='));

                if (!selectedCenterCookie) return null;

                const encodedValue = selectedCenterCookie.split('=')[1];
                const decodedValue = decodeURIComponent(encodedValue);

                try {
                    const selectedCenter = JSON.parse(decodedValue);
                    return selectedCenter.id;
                } catch (e) {
                    console.error('Error parsing selected_center cookie:', e);
                    return null;
                }
            };

            const centerId = getSelectedCenterIdFromCookie();

            if (centerId) {
                axios
                    .get('publicGetCenterDetails/' + centerId)
                    .then((res) => {
                        if (res.data.error) {
                            console.log(res);
                        } else {
                            this.$store.dispatch('center', res.data.data);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            } else {
                this.$router.push('/staff/select_center');
            }
        },

        methods: {},
    };
</script>
